import React, { useState, useEffect } from "react";
import { Typography, Container, Grid } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import VentureBuyerIcon from "../../assets/Icon/VentureBuyerIcon.png";
import CustomDetailedList from "../../components/Custom/CustomDetailedList";

export default function PostRequirement() {
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    api
      .get(`/buyer/requirements/`)
      .then((result) => {
        setData(result.data);
        setLoading(false);
      })
      .catch((err) => {
        alert("Error: " + err.response.data.non_field_errors[0]);
        setLoading(false);
      });
  };
  const handleAddRequirement = () => {
    window.location.href = "/buyer/add-requirement";
  };

  const handleAddRequirementCSV = () => {
    window.location.href = "/buyer/add-csv";
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: "110vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontSize: "30px",
              fontWeight: 700,
              marginTop: "10px",
            }}
          >
            {t("Post a Requirement")}
          </Typography>

          {data.length !== 0 && (
            <div
              style={{
                overflowY: "auto",
                height: "83%",
                textAlign: "center",
                maxHeight: "83%",
              }}
            >
              {data.map((requirement) => (
                <CustomDetailedList
                  key={requirement.id}
                  id={requirement.id}
                  data={[
                    {
                      label: t("Commodity"),
                      value: requirement.commodity.name,
                    },
                    { label: t("Quantity"), value: requirement.quantity },
                    {
                      label: t("Date needed on"),
                      value: requirement.date_needed,
                    },
                    { label: t("District"), value: requirement.district.name },
                    { label: t("Max. Price"), value: requirement.max_price },
                    {
                      label: t("Quality Requirement"),
                      value: requirement.quality_requirement,
                    },
                    {
                      label: t("Who can respond"),
                      value: requirement.responder_type,
                    },
                  ]}
                  buttonList={[]}
                />
              ))}
            </div>
          )}

          {data.length === 0 && (
            <div
              style={{
                height: "85%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  margin: "auto",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={VentureBuyerIcon}
                  alt="My Requirements"
                  style={{
                    width: "127px",
                    height: "127px",
                    marginBottom: "10px",
                  }}
                />

                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2, textAlign: "center" }}
                >
                  {t("Your Requirement will be shown here once you add them.")}
                </Typography>
              </div>
            </div>
          )}
          <Grid container>
            <Grid item xs={12}>
              <CustomButton onClick={handleAddRequirement}>
                {t("Add Requirement")}
              </CustomButton>
            </Grid>

            <Grid item xs={12}>
              <CustomButton onClick={handleAddRequirementCSV} hideIcon>
                {t("Add Requirement by uploading CSV")}
              </CustomButton>
            </Grid>
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}
